import script from "./OperatingPrinciple.vue?vue&type=script&setup=true&lang=js"
export * from "./OperatingPrinciple.vue?vue&type=script&setup=true&lang=js"

import "./OperatingPrinciple.vue?vue&type=style&index=0&id=775f63d5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-775f63d5"]])

export default __exports__